import { render, staticRenderFns } from "./work_manage.vue?vue&type=template&id=f6b284c0&scoped=true"
import script from "./work_manage.vue?vue&type=script&lang=js"
export * from "./work_manage.vue?vue&type=script&lang=js"
import style0 from "./work_manage.vue?vue&type=style&index=0&id=f6b284c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b284c0",
  null
  
)

export default component.exports